import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { AuthGuard } from './auth.guard';
import { LoginService } from './login.service';
import { NotificationService } from '@nuso/common/util-errors';

@Injectable({
  providedIn: 'root'
})
export class CanUseResellerAdminGuard extends AuthGuard {
  /**
   * Check if the user has reseller or admin privileges
   */
  isResellerAdmin(): Observable<boolean> {
    return this.loginService.completedLoginStatus()
      .pipe(
        map(status => {
          if (!status.isLoggedIn || !status.loginSession || !status.loginSession.roles) {
            return false;
          }

          if (status.loginSession.roles.includes('reseller') && status.loginSession.resellerCustomer?.id === status.loginSession.current_customer_id) {
            console.log('Reseller user cannot access admin features for their own customer');
            this.router.navigate(['/']);
          }

          return status.loginSession.roles.includes('admin') ||
                 status.loginSession.roles.includes('superuser') ||
                 status.loginSession.roles.includes('reseller');
        })
      );
  }

  override canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    // First check if the user is authenticated using the parent AuthGuard
    return super.canActivate(route, state).pipe(
      switchMap(isAuthenticated => {
        // If not authenticated, parent AuthGuard already handled the redirect
        if (!isAuthenticated) {
          return of(false);
        }

        // If authenticated, check admin permissions
        return this.isResellerAdmin().pipe(
          tap(isResellerAdmin => {
            if (!isResellerAdmin) {
              console.log('logged in but not reseller or admin');
              this.router.navigate(['/']);
            }
          })
        );
      })
    );
  }
}